import {mediaQueries, pageWidth} from "@repo/shared-styles";

export const moduleHorizontalPadding = 20;
export const moduleHorizontalPaddingSmall = 16;
export const moduleVerticalPadding = 48;
export const moduleVerticalPaddingSmall = 40;
export const moduleVerticalPaddingCompactModifer = -16;
export const moduleVerticalPaddingExpandedModifer = 16;
export const moduleWidthCentered = 608;

// TODO(jordan): These make more sense in modules-package
export const moduleLayout = {
    defaultAlignment: {
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: pageWidth,
    },
    defaultSpacing: {
        paddingBottom: moduleVerticalPadding,
        paddingLeft: moduleHorizontalPadding,
        paddingRight: moduleHorizontalPadding,
        paddingTop: moduleVerticalPadding,

        [mediaQueries.smOrSmaller]: {
            paddingBottom: moduleVerticalPaddingSmall,
            paddingLeft: moduleHorizontalPaddingSmall,
            paddingRight: moduleHorizontalPaddingSmall,
            paddingTop: moduleVerticalPaddingSmall,
        },
    } as {
        paddingBottom: number;
        paddingLeft: number;
        paddingRight: number;
        paddingTop: number;
    },
    rightAlignment: {
        [mediaQueries.lg]: {
            marginLeft: `calc(50% - (${moduleWidthCentered}px / 2))`,
            maxWidth: (moduleWidthCentered +
                (pageWidth - moduleWidthCentered) / 2) as number,
        },
        [mediaQueries.xl]: {
            marginLeft: `calc(50% - (${moduleWidthCentered}px / 2))`,
            maxWidth: (moduleWidthCentered +
                (pageWidth - moduleWidthCentered) / 2) as number,
        },
    } as Record<any, any>,
} as const;
